// src/components/SmartPlansRoute.jsx
import { Navigate } from 'react-router-dom';
import { useClinic } from '../context/ClinicContext';

const SmartPlansRoute = ({ children }) => {
  const { selectedClinicId } = useClinic();

  // Si hay clínica activa, fuerza a /doctor/clinica/planes
  if (selectedClinicId) {
    return <Navigate to="/doctor/clinica/planes" replace />;
  }

  // Si no hay clínica, renderiza los children (PlanesPage individual)
  return children;
};

export default SmartPlansRoute;
